"use client"

import {useEffect, useState} from 'react';
import {Path as PathType} from "@/types/Paths";
import {pathRequest} from "@/utils/api/Path";

const usePathData = (pathId: string) => {
  const [data, setData] = useState<PathType | undefined>(undefined)

  useEffect(() => {
    const fetchData = async () => {
      const fetched = await pathRequest(pathId)
      if (fetched) {
        setData(fetched)
      }
    }
    if (!data) {
      fetchData()
    }
  }, [data, pathId]);

  return data
};

export default usePathData;
